























import { defineComponent, PropType, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import { BModal } from 'bootstrap-vue';
import * as Common from "../commons/common"

export default defineComponent({
  props: {
    okButtonLabel: {
    type: String as PropType<string>,
    required: false,
    default: "OK",
  },
  },
  setup (props, context) {

    const modalConfirmRef = ref<InstanceType<typeof BModal>>();

    const okClick = () => {
      context.emit("ok-click");
    }

    const cancelClick = () => {
      modalConfirmRef.value.hide();
      context.emit("cancel-click");
    }

    const show = () => {
      modalConfirmRef.value.show();
    }

    const hide = () => {
      modalConfirmRef.value.hide();
    }

    const shown = () => {
      context.emit("shown");

      context.root.$nextTick(() => {
        document.getElementById("button-cancel").focus();
      });
    }

    const hidden = () => {
      context.emit("hidden");
    }

    const onButtonFocus = (event: FocusEvent) => {
      // フォーカスが当たったボタンに `focused-button` クラスを追加
      (event.target as HTMLButtonElement).classList.add('focused-button');
      (event.target as HTMLButtonElement).id;
    }

    const onButtonBlur = (event: FocusEvent) => {
      // フォーカスが外れたボタンから `focused-button` クラスを削除
      (event.target as HTMLButtonElement).classList.remove('focused-button');
    }

    const confirmKeyDown = async (e: KeyboardEvent) => {

      // input type="text" or input type="number" or textareaがフォーカスされている場合は処理しない
      if (!Common.isShortcutKeyEnable(document)){
        return;
      }
      
      if(e.key == "ArrowLeft"){
        handleArrowLeft();
      }else if(e.key == "ArrowRight"){
        handleArrowRight();
      }
    }

    const handleArrowLeft = () => {
      const okButton = document.getElementById("button-ok") as HTMLButtonElement;
      const cancelButton = document.getElementById("button-cancel") as HTMLButtonElement;

      if(document.activeElement === okButton){
        cancelButton.focus();
      }else if(document.activeElement === cancelButton) {
        okButton.focus();
      }else{
        cancelButton.focus();
      }
    }

    const handleArrowRight = () => {
      const okButton = document.getElementById("button-ok") as HTMLButtonElement;
      const cancelButton = document.getElementById("button-cancel") as HTMLButtonElement;

      if (document.activeElement === okButton) {
        cancelButton.focus();
      } else if (document.activeElement === cancelButton) {
        okButton.focus();
      } else {
        okButton.focus();
      }
    }

    onMounted(async () => {
      window.addEventListener("keydown", confirmKeyDown);
    });

    onBeforeUnmount(async () => {
      window.removeEventListener("keydown", confirmKeyDown);
    });

    return {
      okClick,
      cancelClick,
      modalConfirmRef,
      show,
      hide,
      shown,
      hidden,
      onButtonFocus,
      onButtonBlur,
    }
  }
});
